import CustomInput from "../../eventcreation/components/CustomInput";
import { makeStyles } from "@mui/styles";
import { customTheme as theme } from "../../../theme/customTheme";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FocusTrap from "@mui/base/FocusTrap";
import useValidator from "../../../hooks/useValidator";
import { afterValidate, setInput } from "../../../utils/commonServices";
import { updateUserState } from "../../../redux/userSlice";
// import useAuthRequest from "../../../hooks/useAuthRequest";
import movieIcon from '../../../assets/movieIcon.svg';
import { Box, Grid, Paper, Typography } from '@mui/material';
import UnauthLayout from '../components/UnauthLayout'
import CustomButton from "../../../components/CustomButton";
import { LoadingButton } from "@mui/lab";
import "@fontsource/rubik";
import { PRODUCT_ID } from "../../../constants/constants";
import useAuthFlow from "../hooks/useAuthFlow";

const useStyles = makeStyles((theme) => ({
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    minHeight: "100%",
  },
}));

const ForgotPassword = (props) => {

    const navigate = useNavigate();
    const [snackbarProps, setSnackbarProps] = useState({});
    const {openHandler, closeHandler} = props;
    const [buttonText, setButtonText] = useState("Next");
    const [successMsg, setSuccessMsg] = useState("");
    const classes = useStyles();
    const [pageData, setPageData] = useState({email: "", product_id: process.env.REACT_APP_PRODUCT_ID});
    const [disableNext, setDisableNext] = useState(false)
    // const [forgotPassword, status] = useAuthRequest("forgot-password", setSnackbarProps)
    
const [errorObjectArray, checkEmptyFields, checkValue] = useValidator(pageData, "forgot-password");
const pendingCallReducer = useSelector((state) => state.pendingCallReducer);
const {forgotUserPassword} = useAuthFlow()



//  useEffect(()=> {
//   if(pendingCallReducer.forgotPasswordStatus == "success") {
//     setTimeout(()=> {
//       navigate('/signin', {replace: true})
//     }, 6000)
 
//   }
//  }, [pendingCallReducer.forgotPasswordStatus])

    const handleClose = () => {
        setTimeout(()=> {
          navigate('/signin', {replace: true});
        }, 200);
        closeHandler(false);
      };

      const onBlurHandler = async (event)=> {
        await checkValue(event, true)
      }

      const nextCLickHandler = async (event)=> {
        
       setDisableNext(true)
       await checkEmptyFields(event);
       await checkValue(event, true);
       await onBlurHandler({target: {id: "email", value: pageData?.email}})
       
     
           setTimeout(()=> {
            afterValidate(afterValidateEmailSubmition)
           }, 1000)
        
      }

   
      const afterValidateEmailSubmition = ()=> {
             forgotUserPassword(pageData)
      }

        //code to detect enter key for editing Organization Name
  useEffect(() => {
    const keyDownHandler = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            nextCLickHandler(event);
        }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
        document.removeEventListener('keydown', keyDownHandler);
    };
}, [pageData]);
  
    

  return (
    <UnauthLayout both>
         <Box  pb={4}>
           <Box className={classes.centerBox} flexDirection='column'>
            
           <Box sx={{marginY:{xs:'15px',md:'20px',lg:'25px',xl:'38px'}}}>
           <Typography
                variant="h4"
                color="primary"
                style={{
                  fontWeight: 600,
                  color:'#ffffff'
                }}
                sx={{fontSize:{xs:'30px',sm:'25px',md:'35px',lg:'41px',xl:'60px'}, fontFamily:'Rubik'}}
              >Forgot Password</Typography>
            </Box>
            <Box item gap={0.8} sx={{display:'flex', flexDirection:'column', width:{xs:'200px', sm:'300px', lg:'400px', xl:'600px'}}}>
              <CustomInput
                id= {errorObjectArray[0]?.id}
                onFocus = {(e)=>{checkEmptyFields(e); setDisableNext(false) }}
                onBlur = {onBlurHandler}
                required
                errorFlag= {errorObjectArray[0]?.errorFlag}
                errorMsg= {errorObjectArray[0]?.error}
                type="text"
                max={40}
                placeholder="Email Address*"
                 onChange={(event) => setInput(pageData?.email != "" ? event.target.value : event.target.value.trim() , "email", pageData, setPageData)}
                 value={pageData?.email}       
              />
              </Box>
            <Box width='100%' sx={{mt: 1, display: 'flex', flexDirection: {xs: 'column-reverse', sm: 'row'}, justifyContent: { xs: 'flex-start', sm: 'flex-end'}, alignItems: {xs: 'center', sm: 'flex-start'} }} >
                {/* <CustomButton
                    btnText= 'BACK'
                   // disabled = {status == "loading"}
                    variant="outlined"
                    color="primary"
                    size="medium"
                    onClick = {()=> navigate('/signin', {replace: true})}
                    style={{
                    fontSize: 18,
                    borderRadius: 50,
                    maxWidth: 170,
                    minWidth: 90,
                    marginTop: 30
                    }}
                /> */}
                 <CustomButton variant="text" 
                    btnText="Back" 
                    style={{borderRadius: '5px', border:"none",  textTransform:'none', color:'#21D644'}}  
                    onClick= {()=> navigate('/signin', {replace: true})}
                    sx={{fontSize:{xs:'10px',sm:'10px',md:'11px',lg:'12px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'60px',lg:'65px',xl:'88px'}, fontFamily:'Rubik'}}/>
                
                {/* <CustomButton
                    btnText={buttonText}
                    disabled = {(disableNext == true && !errorObjectArray[0]?.errorFlag) || status == 'loading' || status == 'success'}
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick = {buttonText == "Next" ? nextCLickHandler : handleClose}
                    style={{
                    fontSize: 18,
                    borderRadius: 50,
                    maxWidth: 170,
                    minWidth: 90,
                    marginTop: 30
                    }}
                /> */}
                 <LoadingButton
                    disabled={(disableNext == true && !errorObjectArray[0]?.errorFlag) || pendingCallReducer.forgotPassword}
                    onClick = {buttonText == "Next" ? nextCLickHandler : handleClose}
                    style={{borderRadius: '5px', backgroundColor:'#00CEFF', color:'#08231B', textTransform:'none', }} 
                    sx={{height:{xs:'18px',sm:'20px',md:'22px', lg:'23px', xl:'35px'}, width:{xs:'70px', lg:'90px',xl:'129px'}, fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600,  minWidth: '94px !important' }}
                    loading={pendingCallReducer.forgotPassword}
                    loadingPosition="start"
                    variant="contained"
                    >
                   {buttonText}
               </LoadingButton> 
            </Box>
                  
           </Box>

         </Box>
    </UnauthLayout>
  )
}

export default ForgotPassword